import PropTypes from "prop-types";
import { memo, useCallback } from "react";
import Radio from "app/pages/.shared/form/Radio.jsx";
import AmountContainer from "app/pages/.shared/AmountContainer.jsx";
import { FormattedMessage } from "react-intl";
import get from "lodash/get";
import Button from "app/pages/.shared/form/Button";
import IconRight from "app/pages/.shared/static/icons/IconRight";

const DepartureCity = ({
	field,
	onChange,
	departureCity,
	amountSuffix,
	productInfo,
	showCTA,
	...props
}) => {
	const handleChange = useCallback(() => {
		onChange(departureCity);
	}, [departureCity]);

	return (
		<Radio
			field={field}
			id={departureCity.code}
			value={departureCity.code}
			toggle={handleChange}
			checked={field.value === departureCity.code}
			data-testid={props["data-testid"]}
		>
			<div className="departure-city__content">
				<div className="departure-city__label">
					<span>{departureCity.label}</span>
					{productInfo.ul === true && (
						<div className="departure-city__info">
							<FormattedMessage id="search.engine.departure.city.info.business.flight" />
						</div>
					)}
				</div>
				<div className="departure-city__price">
					<AmountContainer
						amount={get(departureCity, "from.p")}
						prefix={<FormattedMessage id="offer.per.person.from.label" />}
						suffix={amountSuffix}
					/>
					{showCTA && (
						<div className="departure-city__cta">
							<Button variant="primary">
								<IconRight width={12} height={12} />
							</Button>
						</div>
					)}
				</div>
			</div>
		</Radio>
	);
};

DepartureCity.defaultProps = {
	field: {},
	departureCity: {},
	productInfo: {},
};

DepartureCity.propTypes = {
	productInfo: PropTypes.object,
	departureCity: PropTypes.object,
	amountSuffix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	field: PropTypes.object,
	onChange: PropTypes.func,
	showCTA: PropTypes.bool,
	"data-testid": PropTypes.string,
};

export default memo(DepartureCity);
